const explorerByChainId = {
    1: 'https://etherscan.io',
    56: 'https://bscscan.com',
    66: 'https://www.oklink.com/oktc',
    97: 'https://testnet.bscscan.com',
    128: 'https://hecoinfo.com',
    1030: 'https://evm.confluxscan.io',
    1116: 'https://scan.coredao.org',
    8453: 'https://basescan.org',
    10001: 'https://www.oklink.com/ethw',
    42161: 'https://arbiscan.io',
}

export function shortenCryptoValue(value, start = 6, end = 4) {
    if (!value || value.length <= start + end + 3) return value || ''
    return `${value.slice(0, start)}...${value.slice(-end)}`
}

export function getTransactionHash(tx, receipt) {
    return receipt?.transactionHash || receipt?.hash || tx?.hash || ''
}

export async function waitForTransaction(tx) {
    const receipt = await tx.wait()
    return {
        receipt,
        txHash: getTransactionHash(tx, receipt),
    }
}

export function getTransactionExplorerUrl(chainId, txHash) {
    const explorer = explorerByChainId[Number(chainId)]
    if (!explorer || !txHash) return ''
    return `${explorer}/tx/${txHash}`
}
